import { useContext } from 'react';

import { FrameworkContext } from '../context';

export function useFramework(): FrameworkContext {
  const context = useContext(FrameworkContext);

  if (!context) {
    throw new Error('Invalid hook call');
  }

  return context;
}
